import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'
import { MessagingChannelHelperService } from '../messaging-channel-helper.service'

@Component({
  selector: 'app-connect-gmail-dialog',
  templateUrl: './connect-gmail-dialog.component.html',
  host: { class: 'modal-content' },
  styleUrls: ['./connect-gmail-dialog.component.scss'],
})
export class ConnectGmailDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConnectGmailDialogComponent>,
    private helper: MessagingChannelHelperService
  ) {}

  close() {
    this.dialogRef.close()
  }

  onConnect() {
    this.helper.connect('gmail').subscribe(() => {
      this.close()
    })
  }
}
